import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, User, ArrowRight, ShieldCheck } from "lucide-react";
import { useAdminAuth } from "../../context/AuthContext";

const AdminLogin = () => {
    const { adminLogin } = useAdminAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        const r = await adminLogin({ username, password });
        if (!r.ok) return toast.error(r.error);
        toast.success("Welcome.");
        navigate("/admin");
    };

    return (
        <div className="min-h-screen mmt-hero-gradient flex items-center justify-center p-4" data-testid="admin-login-page">
            <div className="absolute inset-0 kerala-pattern opacity-15 pointer-events-none" />
            <div className="relative w-full max-w-md bg-white rounded-2xl p-8 shadow-2xl">
                <div className="w-14 h-14 rounded-2xl mmt-saffron-gradient flex items-center justify-center text-white mb-4 shadow-md">
                    <ShieldCheck className="w-7 h-7" />
                </div>
                <h1 className="font-display text-3xl text-ink">Admin sign in</h1>
                <p className="text-ink-light text-sm mt-1">Restricted area · SouthTrip operations panel.</p>

                <form onSubmit={submit} className="mt-6 space-y-4" autoComplete="off">
                    <div className="relative">
                        <User className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-light" />
                        <input
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            placeholder="Username"
                            autoComplete="off"
                            className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-cream-200 bg-white"
                            data-testid="admin-username"
                        />
                    </div>
                    <div className="relative">
                        <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-light" />
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Password"
                            autoComplete="new-password"
                            className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-cream-200 bg-white"
                            data-testid="admin-password"
                        />
                    </div>
                    <button type="submit" className="w-full px-5 py-3 rounded-xl bg-navy-600 hover:bg-navy-700 text-white font-semibold flex items-center justify-center gap-2 transition shadow-md" data-testid="admin-submit">
                        Sign in <ArrowRight className="w-4 h-4" />
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
